import { motion } from "framer-motion";
import buildingCorner from "@/assets/building-corner.png";
import { MapPin } from "lucide-react";

const nearby = [
  { name: "University (FON)", distance: "Right across the street" },
  { name: "Restaurants & Nightlife", distance: "Walking distance" },
  { name: "LIDL Supermarket", distance: "2 min walk" },
  { name: "Shopping Center", distance: "5 min walk" },
  { name: "Old Bazaar (12th-century)", distance: "4 km" },
  { name: "Kale Fortress", distance: "5 km" },
  { name: "Stone Bridge", distance: "6 km" },
  { name: "Macedonia Square", distance: "6 km" },
  { name: "Skopje International Airport", distance: "17 km" },
];

const LocationSection = () => {
  return (
    <section id="location" className="py-24 md:py-32 px-6 md:px-16 bg-card">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-muted-foreground font-body text-sm tracking-[0.3em] uppercase mb-3">
              Location
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-4">
              Heart of Skopje
            </h2>
            <p className="font-body text-muted-foreground mb-2 flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1 text-foreground shrink-0" />
              Kiro Gligorov 3, Skopje 1000, Macedonia
            </p>
            <p className="font-body text-muted-foreground mb-8">
              Steps from a university, shopping, dining, and entertainment—with major landmarks just minutes away.
            </p>

            <div className="space-y-3">
              {nearby.map((place) => (
                <div
                  key={place.name}
                  className="flex items-center justify-between border-b border-border pb-3 last:border-0"
                >
                  <span className="font-body text-sm text-foreground">{place.name}</span>
                  <span className="font-body text-xs text-muted-foreground tracking-wide">
                    {place.distance}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <img
              src={buildingCorner}
              alt="Urbanova building corner view"
              className="rounded-2xl w-full object-cover aspect-[4/5]"
            />
            <div className="absolute -bottom-4 -left-4 bg-foreground text-background rounded-xl px-6 py-4 font-heading text-2xl font-bold shadow-lg">
              from €40<span className="text-sm font-body font-normal opacity-60 ml-1">/night</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
